<template>
	<div>
		<div class="full-width section-medium bg-gray-light mb-5">
			<div class="container">
				<div class="showcase-app__filtering row">
					<div class="showcase-app__filtering-col col-md-12 col-lg-2">
						<div class="showcase-app__filter-head h4">{{ translations?.FilterBy }}</div>
					</div>
					<div class="showcase-app__filtering-col col-md-6 col-lg-5">
						<ShowcaseFilter
							filter="Portfolio"
							:filterOptions="showcaseFilterPortfolioData"
							v-on:filterChange="filterChange">
							<template v-slot:filterTitle>
								{{ translations?.Portfolio }}
							</template>
						</ShowcaseFilter>
					</div>
					<div class="showcase-app__filtering-col col-md-6 col-lg-5">
						<ShowcaseFilter
							filter="ShowcaseStyle"
							:filterOptions="showcaseFilterStyleData"
							v-on:filterChange="filterChange">
							<template v-slot:filterTitle>
								{{ translations?.Style }}
							</template>
						</ShowcaseFilter>
					</div>
				</div>
			</div>
		</div>
		<div class="showcase-app__container">
			<template v-if="showcases && showcases.length === 0">
				<div>
					{{ translations?.NoMatchingShowcases }}
				</div>
			</template>
			<template v-else>
				<ul class="showcase-app__list">
					<li class="showcase-app__item" v-for="(showcase, index) in showcases" :key="index">
						<ShowcaseCard
							:credits="showcase.Credits"
							:url="showcase.UrlName"
							:index="index"
							:styleValue="showcase.ShowcaseStyle.PersistedValue"
							:styleName="showcase.ShowcaseStyle.Text"
							:portfolio="showcase.Portfolio.PersistedValue"
							:portfolioName="showcase.Portfolio.Text"
							:title="showcase.Title"
							:image="showcase.Image"
							:imageAltText="showcase.ImageAltText"
						></ShowcaseCard>
					</li>
				</ul>
			</template>
		</div>
		<div class="text-center section-small-md-up" v-if="buttonEnabled === true">
			<button @click="showAllTrigger" class="btn btn-primary btn-lg">{{ translations?.ShowMore }}</button>
		</div>
		<div class="load-indicator" :class="{ 'state-visible': loadingResults === true }">
			<div class="load-indicator__indicator"></div>
			<span class="load-indicator__text">{{ translations?.Loading }}</span>
		</div>
		<div class="load-indicator-cover" :class="{ 'state-visible': loadingResults === true }"></div>
	</div>
</template>
<script lang="ts">
//@ts-ignore
import {IShowcase, IShowcaseData, IShowcaseTranslations} from "../interfaces/Interfaces";
import { GetShowcaseData } from "Api/apis";
import ShowcaseFilter from "Vue/components/showcase/ShowcaseFilter.vue";
import ShowcaseCard from "Vue/components/showcase/ShowcaseCard.vue";

export default {
	name: "Showcase",
	components: {
		ShowcaseFilter,
		ShowcaseCard
	},
	data() {
		return {
			showcaseFilterPortfolioData: [],
			showcaseFilterStyleData: [],
			showcases: [] as IShowcase[],
			translations: {} as IShowcaseTranslations,
			showcasesOriginal: [],
			loadingResults: false,
			isEmpty: false,
			showcaseStyle: '',
			portfolio: '',
			showAll: false,
			buttonEnabled: false
		};
	},
	methods: {
		/**
		 * @param value - value param is an array, value[0] = Filter Type value[1] passed in value from ShowcaseFilter component
		 */
		async filterChange(value) {
			let urlParams = new URLSearchParams(window.location.search);

			/**
			 * These two if statements check for
			 */
			if(value[0] === 'ShowcaseStyle') {
				this.showcaseStyle = value[1] ? value[1] : '';
				this.portfolio = urlParams.get('portfolio') ? urlParams.get('portfolio') : '';
			}
			if(value[0] === 'Portfolio') {
				this.portfolio = value[1] ? value[1] : '';
				this.showcaseStyle = urlParams.get('showcaseStyle') ? urlParams.get('showcaseStyle') : '';
			}

			let path = window.location.href;
			let pathWithoutParams = path.indexOf('?') !== -1 ? window.location.href.split('?')[0] : window.location.href
			await history.replaceState(null, 'Baldwin Showcases', `${pathWithoutParams}?showcaseStyle=${this.showcaseStyle}&portfolio=${this.portfolio}&showAll=${this.showAll}`);
			await this.filterRequest();
		},

		async checkForExistingParams() {
			let urlParams = new URLSearchParams(window.location.search);
			if(urlParams.has('showcaseStyle') || urlParams.has('portfolio') || urlParams.has('showAll')) {
				if(urlParams.has('showcaseStyle')) {
					this.showcaseStyle = urlParams.get('showcaseStyle');
				}
				if(urlParams.has('portfolio')) {
					this.portfolio = urlParams.get('portfolio');
				}
				if(urlParams.has('showAll')) {
					this.showAll = urlParams.get('showAll');
				}
			}
		},

		async apiRequest() {
			let currentParams = {
				showcaseStyle: this.showcaseStyle,
				portfolio: this.portfolio,
				showAll: this.showAll
			}

			let newShowroomData = await GetShowcaseData(currentParams);
			this.showcases = newShowroomData.Showcases;
			this.showcaseFilterPortfolioData = newShowroomData.Portfolios;
			this.showcaseFilterStyleData = newShowroomData.Styles;
			this.buttonEnabled = newShowroomData.HasMoreResults === true;
		},

		async showAllTrigger() {
			this.showAll = true;
			let path = window.location.href;
			let pathWithoutParams = path.indexOf('?') !== -1 ? window.location.href.split('?')[0] : window.location.href
			history.replaceState(null, 'Baldwin Showcases', `${pathWithoutParams}?showcaseStyle=${this.showcaseStyle}&portfolio=${this.portfolio}&showAll=${this.showAll}`);
			await this.filterRequest();
		},

		async getShowcaseData() {
			let showcaseDiv = document.getElementById('showcaseData');
			return JSON.parse(showcaseDiv.getAttribute('data-page-data'));
		},

		async filterRequest() {
			this.loadingResults = true;
			await this.apiRequest();
			setTimeout(() => {
				this.loadingResults = false;
			}, 1000)
		},

		/**
		 * Get the showcase and filter data from the API
		 */
		async setData() {
			const showcaseData:IShowcaseData = await this.getShowcaseData();
			this.showcases = showcaseData.Showcases;
			this.showcaseFilterPortfolioData = showcaseData.Portfolios;
			this.showcaseFilterStyleData = showcaseData.Styles;
			if(showcaseData.HasMoreResults === true) {
				this.buttonEnabled = true;
			}
		},
		/**
		 * Get translations from off the #showcaseData div located at
		 * SitefinityWebApp/Mvc/Views/ProjectShowcaseLanding/Index.cshtml
		 */
		getTranslations() {
			let showcasesDiv = document.getElementById('showcaseData');
			return JSON.parse(showcasesDiv.getAttribute('data-translations'));
		}
	},
	async created() {
		this.translations = this.getTranslations();
		await this.setData();
		await this.checkForExistingParams();
		await this.filterRequest();
	}
};
</script>
